import {
  COUNTRIES,
  DEFAULT_COUNTRY,
  parseQueryString,
  QueryParameters
} from '@moda/portal-stanchions';
import { UseCookiesQuery_cookies as Cookies } from '../../generated/types/UseCookiesQuery';
import { decode as decodePreferences } from '../../hooks/usePreferences/tools';

const getQueryParameters = (cookies: Cookies, url: string) => {
  const queryParams = parseQueryString(url.split('?')[1] || '');
  const sessionQueryParams: QueryParameters = JSON.parse(cookies.sessionQueryParams ?? '{}');

  return {
    ...sessionQueryParams,
    ...queryParams
  };
};

export const getSearchApiHeaders = (cookies: Cookies, url: string) => {
  const queryParams = getQueryParameters(cookies, url);
  const urlCountry = queryParams.country
    ? COUNTRIES.find(
        ({ alpha2Code, alpha3Code }) =>
          queryParams.country === alpha2Code || queryParams.country === alpha3Code
      )
    : undefined;

  const { cloudfrontViewerCountry } = cookies;
  const preferences = decodePreferences(cookies.preferences);
  const preferencesCountry =
    COUNTRIES.find(country => country.id === preferences.countryId) || DEFAULT_COUNTRY;

  return {
    'client-country-code': urlCountry
      ? urlCountry.alpha2Code
      : cloudfrontViewerCountry && cloudfrontViewerCountry !== 'US'
      ? cloudfrontViewerCountry
      : preferencesCountry.alpha2Code,
    'ab-tests': ['restrict-designers-to-us', 'no-trunkshow-on-new'].join(',')
  };
};
